import { AppProviders } from '@/app/providers';
import { ErrorBoundary } from '@/shared/components/error-boundary';
import { AppRouter } from '@/app/router';
import { setBearerProvider } from '@/api';
import { readAuthToken } from '@/shared/utils/auth-token';

// Install the dev-mode bearer provider once at module load. The interceptor
// calls this on every request and reads the latest token from localStorage,
// so a sign-in/sign-out flips the header on subsequent calls without any
// re-registration.
setBearerProvider(async () => readAuthToken());

export function App() {
    return (
        <AppProviders>
            <ErrorBoundary>
                <AppRouter />
            </ErrorBoundary>
        </AppProviders>
    );
}
